import { render, staticRenderFns } from "./AnalysisStatusTag.vue?vue&type=template&id=40b92d6f&"
import script from "./AnalysisStatusTag.vue?vue&type=script&lang=ts&"
export * from "./AnalysisStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports